import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  ModalComponent,
  ModalTitleDirective,
} from '@totalenergiescode/tds-angular';
import { Analyst } from '@scenario/models/analyst.model';

@Component({
    selector: 'app-psf-modal',
    templateUrl: './psf-analyst-modal.component.html',
    styleUrl: './psf-analyst-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ModalComponent,
    ModalTitleDirective,
  ],
})
export class PsfAnalystModalComponent {
  analyst = input<Analyst>();
}
